module.exports = __webpack_public_path__ + "static/02-200f080fccfe329332c22f99b1478568.jpg";